import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Route } from "react-router-dom";
import BuildingOffers from "./Offers";
import BuildingDashboard from "./Dashboard";
import BuildingNotifications from "./Notifications";
import ListServices from "./Services/List";
import CreateService from "./Services/Create";
import EditService from "./Services/Edit";
import CreateOffer from "../Offers/CreateOffer";
import CreateNotification from "../Notifications/Create";
import DuplicateNotification from "../Notifications/Duplicate";
import EditNotification from "../Notifications/Edit";
import CreateQuickLink from "../QuickLinks/Create";
import EditQuickLink from "../QuickLinks/Edit";
import AdminOfferReview from "../Offers/AdminOfferReview";
import ListContactTopics from "./ContactTopics/List";
import QuickLinks from "./QuickLinks";
import CreateContactTopic from "./ContactTopics/Create";
import EditContactTopic from "./ContactTopics/Edit";

const Building = ({ match }) => (
  <Fragment>
    <Route exact path={`${match.url}`} component={BuildingDashboard} />
    <Route exact path={`${match.url}/offers`} component={BuildingOffers} />
    <Route
      exact
      path={`${match.url}/notifications`}
      component={BuildingNotifications}
    />
    <Route
      path={`${match.url}/notifications/new`}
      component={CreateNotification}
    />
    <Route
      path={`${match.url}/notifications/edit/:notificationId`}
      component={EditNotification}
    />
    <Route
      path={`${match.url}/notifications/duplicate/:notificationId`}
      component={DuplicateNotification}
    />
    <Route path={`${match.url}/offers/new`} component={CreateOffer} />
    <Route
      path={`${match.url}/offers/review/:offerId`}
      component={AdminOfferReview}
    />
    <Route exact path={`${match.url}/services`} component={ListServices} />
    <Route path={`${match.url}/services/new`} component={CreateService} />
    <Route
      path={`${match.url}/services/edit/:serviceId`}
      component={EditService}
    />

    <Route exact path={`${match.url}/quick_links`} component={QuickLinks} />
    <Route path={`${match.url}/quick_links/new`} component={CreateQuickLink} />
    <Route
      path={`${match.url}/quick_links/edit/:notificationId`}
      component={EditQuickLink}
    />
    <Route
      exact
      path={`${match.url}/contact_topics`}
      component={ListContactTopics}
    />
    <Route
      path={`${match.url}/contact_topics/new`}
      component={CreateContactTopic}
    />
    <Route
      path={`${match.url}/contact_topics/edit/:contactTopicId`}
      component={EditContactTopic}
    />
  </Fragment>
);

Building.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default Building;
